import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { SignStatusEnum } from '../../enum/signStatusEnum';

interface IOnCloseEvent {
  evento: 'CONFIRMAR' | 'CANCELAR';
  dados: { idPaper: number[], signatureStatus: SignStatusEnum } | null;
}

@Injectable({
  providedIn: 'root'
})
export class ModalConfirmDescartPaperNoActionService {
  public onCloseEvent: Subject<IOnCloseEvent> = new Subject<IOnCloseEvent>();

  constructor() { }
  private subject = new Subject<{ idPaper: number[], signatureStatus: SignStatusEnum }>();

  public getObservable(): Observable<{ idPaper: number[], signatureStatus: SignStatusEnum }> {
    return this.subject.asObservable();
  }

  public showModalConfirm(pData: { idPaper: number[], signatureStatus: SignStatusEnum }): void {
    this.subject.next(pData);
  }
}
